import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { queryClient } from '@/lib/react-query/queryClient';
import { authEndpoints } from '@/modules/auth/constants';
import type { ApiRequestBody } from '@/types/utils/request';

type LoginBodyApi = ApiRequestBody<typeof authEndpoints.login, 'post'>;

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (body: LoginBodyApi) => {
      const { data } = await fetchClient.POST(authEndpoints.login, {
        body,
      });
      return data;
    },
    onSuccess: () => {
      // Invalidate all queries after login to ensure we get the latest data for the current user
      queryClient.resetQueries();
    },
  });
};
